import { ReactNode } from 'react';

export type DesignCardProps = {
  /** Uppercase card title; left out when the card speaks for itself. */
  title?: string;
  children: ReactNode;
  className?: string;
};

const DesignCard = ({ title, children, className }: DesignCardProps) => (
  <section
    className={`rounded-sm border border-design-secondary-black bg-light-gray p-5 dark:bg-design-gray ${className}`}
  >
    {title && (
      <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-light-black dark:text-sublte-white">
        {title}
      </h3>
    )}
    {children}
  </section>
);

DesignCard.defaultProps = {
  title: undefined,
  className: '',
};

export default DesignCard;
